import * as Sentry from '@sentry/nextjs';

type ProductOptionError = {
  message: string;
  originalError?: unknown;
};

export const reportProductOptionError = (error: ProductOptionError) => {
  console.error(`Product Option Error:`, error.message, error.originalError);

  Sentry.withScope((scope) => {
    scope.setTag('page', 'product_option');
    scope.setTag('error_type', 'product_option_error');
    scope.setContext('error_context', {
      message: error.message,
      originalError: error.originalError,
    });
    Sentry.captureMessage('[PRODUCT_OPTION] Product option error');
  });
};
